var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      staticClass: "pt-4",
      attrs: {
        width: 2290,
        height: 1000,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", {
        attrs: { rx: "5", height: "47", width: "2290", y: "0", x: "0" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "5", height: "47", width: "2290", y: "49", x: "0" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "5", height: "47", width: "2290", y: "98", x: "0" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "5", height: "47", width: "2290", y: "147", x: "0" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "5", height: "47", width: "2290", y: "196", x: "0" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "5", height: "47", width: "2290", y: "245", x: "0" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "5", height: "47", width: "2290", y: "294", x: "0" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "5", height: "47", width: "2290", y: "343", x: "0" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "5", height: "47", width: "2290", y: "392", x: "1" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "5", height: "47", width: "2290", y: "441", x: "0" },
      }),
      _vm._v(" "),
      _c("rect", { attrs: { rx: "5", height: "47", width: "2290", y: "490" } }),
      _vm._v(" "),
      _c("rect", { attrs: { rx: "5", height: "47", width: "2290", y: "539" } }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "5", height: "47", width: "2290", y: "588", x: "0" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "5", height: "47", width: "2290", y: "637", x: "0" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "5", height: "47", width: "2290", y: "686", x: "0" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "5", height: "47", width: "2290", y: "735", x: "0" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "5", height: "47", width: "2290", y: "784", x: "0" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "5", height: "47", width: "2290", y: "833", x: "0" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "5", height: "47", width: "2290", y: "883", x: "0" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "5", height: "47", width: "2290", y: "931", x: "0" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }